import React from 'react';
import GenericMasterHeader from './GenericMasterHeader';
import RNSearch from "../select/RNSearch";
import { RNWorkOrderRow } from "../hooks/useRNWorkOrderList";

interface IngredientMasterHeaderProps {
    isCreating: boolean;
    isSaving: boolean;
    hasChanges?: boolean;
    onReset: () => void;
    onSave: () => void;
    onDelete?: () => void;
    deleteDisabled?: boolean;
    deleteDisabledTitle?: string;
    onArchive?: () => void;
    hasIngredient?: boolean;
    search: string;
    setSearch: (val: string) => void;
    rows: RNWorkOrderRow[];
    loading: boolean;
    page: number;
    totalPages: number;
    total: number;
    absoluteTotal: number;
    setPage: (p: number) => void;
    onIngredientSelect?: (row: RNWorkOrderRow) => void;
    ingredientCode?: string;
    ingredientName?: string;
    currentIngredientId?: string;
    currentIngredientCode?: string; // FIX 1: explicit code for stable toolbar display
    onPrintPdf?: () => void;
    renderExcelExport?: () => React.ReactNode;
    onModalOpen?: () => void;
    children?: React.ReactNode;
}

const RNMasterHeader: React.FC<IngredientMasterHeaderProps> = ({
    isCreating,
    isSaving,
    hasChanges = true,
    onReset,
    onSave,
    onDelete,
    deleteDisabled,
    deleteDisabledTitle,
    onArchive,
    hasIngredient,
    search,
    setSearch,
    rows,
    loading,
    page,
    totalPages,
    total,
    absoluteTotal,
    setPage,
    onIngredientSelect,
    ingredientCode,
    ingredientName,
    currentIngredientId,
    currentIngredientCode,
    onPrintPdf,
    renderExcelExport,
    onModalOpen,
    children,
}) => {
    return (
        <GenericMasterHeader
            entityLabel={ingredientCode || ''}
            entityCode={ingredientName}
            entityId={currentIngredientId}
            shortcutCategory="ingredients"
            isCreating={isCreating}
            isSaving={isSaving}
            hasChanges={hasChanges}
            hasEntity={hasIngredient}
            onSave={onSave}
            onNew={onReset}
            onDelete={onDelete}
            deleteDisabled={deleteDisabled}
            deleteDisabledTitle={deleteDisabledTitle}
            onArchive={onArchive}
            onPrintPdf={onPrintPdf}
            renderExcelExport={renderExcelExport}
            children={children}
            renderSearch={() => (
                <RNSearch
                    search={search}
                    setSearch={setSearch}
                    rows={rows}
                    loading={loading}
                    page={page}
                    totalPages={totalPages}
                    total={total}
                    absoluteTotal={absoluteTotal}
                    setPage={setPage}
                    onSelect={onIngredientSelect}
                    currentIngredientId={currentIngredientId}
                    currentIngredientCode={currentIngredientCode}
                    onModalOpen={onModalOpen}
                />
            )}
        />
    );
};

export default RNMasterHeader;
